const FormContainer = props => {
	return (
		<div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-8">
			<div className="w-full lg:w-[395px] mx-auto">{props.children}</div>
		</div>
	);
};

export default FormContainer;
